import type { MarkerOperator } from "@chargetrip/javascript-sdk";

// Disabled until Porsche provides us with a setup to handle these Porsche operators.
// Icons are currently missing for this one.
// const defaultOperators = [
//   "6784622135476197ae4fd326",
//   "64f92eae0fddc9b91a59d785",
//   "652d16f06ef3fa475f1f2a83",
//   "622625c941853c61ee8a9382",
//   "653b19afa041ce60c862e6a2",
//   "624e2a6e6878f895895c5e6e",
//   "624e337e6878f8958962590e",
//   "63b62f26d759b97baf951da4",
//   "63d08d289787ebe3bc16ffec",
//   "622625ca41853c61ee8a94fc",
//   "6445e314aea0bf66c2b6a9b0",
//   "62294075c137b6a394a171e7",
// ];

export const destinationOperators = [
  "622625ca41853c61ee8a9520",
  "63338e8e7f3e2e69d841bde4",
];

export const loungeOperators = ["64c07e41b99ee00371d8b9f0"];

// export const operatorIds = {
//   markers: {
//     100: defaultOperators,
//     200: defaultOperators,
//     300: defaultOperators,
//   },
// };

// export const operatorMarkerDefaults: Pick<
//   MarkerOperator,
//   "offset" | "annotationOffset" | "name"
// > = {
//   name: "PORSCHE",
//   offset: [60, -21],
//   annotationOffset: [138, -44],
// };

export const destinationMarker: MarkerOperator = {
  name: "PORSCHE-DESTINATION",
  offset: [60, -21],
  annotationOffset: [138, -44],
  ids: destinationOperators,
};

export const loungeMarker: MarkerOperator = {
  name: "PORSCHE-LOUNGE",
  offset: [60, -21],
  annotationOffset: [138, -44],
  ids: loungeOperators,
};
